




































import { Component, Vue } from "vue-property-decorator";
import Information from "@/components/Information.vue";

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  components: { Information },
})
export default class Home extends Vue {
  public cards = [
    {
      title: "メトロノーム",
      img: require("@/assets/mode/metronome_mode.png"),
      url: "/metronome",
      cols: 12,
    },
    {
      title: "<span class='no-wrap'>リズムで</span>フラッシュ",
      img: require("@/assets/mode/rhythm_mode.png"),
      url: "/rhythm_flash",
      cols: 6,
    },
    {
      title: "<span class='no-wrap'>テンポ当て</span>ゲーム",
      img: require("@/assets/mode/guessTempo_mode.png"),
      url: "/guess_tempo",
      cols: 6,
    },
  ];

  public get isXs() {
    return this.$vuetify.breakpoint.name === "xs";
  }
}
